<template>
	<div class="contact" :class="{ 'gray': gray }">
		<div class="box">
			<SubTitle width='15rem' topTitle='CONTACT US' :title="$t('content.contact')"
				:content='contactText.content' />

			<p style="margin-top: 5rem;">{{ $t('contact.address') }}：<span v-html="contactText.address"></span></p>
			<p>{{ $t('contact.email') }}：<span v-html="contactText.email"></span></p>

			<form action="javascript:;" method="">
				<div class="form-row">
					<div class="form-item item">
						<p>{{ $t('contact.name') }}*</p>
						<input :style="{ border: arr.indexOf(1) > -1 && !form.name ? '1px solid #FF001F' : 'none' }"
							type="text" name="name" id="" v-model.trim="form.name" />
						<p v-if="arr.indexOf(1) > -1 && !form.name" style="color: #FF001F;">{{ $t('contact.bitian') }}
						</p>
					</div>
					<div class="form-item item">
						<p>{{ $t('contact.xing') }}*</p>
						<input :style="{ border: arr.indexOf(2) > -1 && !form.surname ? '1px solid #FF001F' : 'none' }"
							type="text" name="surname" id="" v-model.trim="form.surname" />
						<p v-if="arr.indexOf(2) > -1 && !form.surname" style="color: #FF001F;">{{ $t('contact.bitian')
						}}</p>
					</div>
				</div>
				<div class="form-row">
					<div class="form-item">
						<p>{{ $t('contact.email') }}*</p>
						<input :style="{ border: arr.indexOf(3) > -1 && !form.email ? '1px solid #FF001F' : 'none' }"
							type="text" name="email" id="" v-model.trim="form.email" />
						<p v-if="arr.indexOf(3) > -1 && !form.email" style="color: #FF001F;">{{ $t('contact.bitian') }}
						</p>
					</div>
				</div>
				<div class="form-row">
					<div class="form-item">
						<p>{{ $t('contact.zhushi') }}</p>
						<textarea rows="" name="message" cols="" v-model.trim="form.message"></textarea>
					</div>
				</div>
				<div class="bottom">
					<input type="submit" name="" id="submit" @click.stop="hSubmit" :value="$t('contact.submit')" />
				</div>
			</form>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import {
	getContactText,
	submitContact
} from '@/utils/api.js'
import SubTitle from './SubTitle'
export default {
	name: 'Contact',
	components: {
		SubTitle
	},
	data() {
		return {
			contactText: {},
			form: {
				surname: '', // 姓
				name: '', // 名
				email: '', // 邮箱
				message: '', // 注释
			},
			arr: []	// 是否显示红色边框 1 名 , 2 姓 , 3 邮箱
		}
	},
	computed: {
		...mapState(['gray'])
	},
	created() {
		this.getContactText()
	},
	methods: {
		async getContactText() {
			const res = await getContactText()
			if (res.code == 200) {
				this.contactText = res.content
			}
		},
		async hSubmit() {

			// console.log("this.arr: ",this.arr);
			if (!this.form.name && !this.form.surname && !this.form.email) {
				return this.arr = [1, 2, 3]
			}
			if (!this.form.name) {
				return this.arr.push(1)
			}
			if (!this.form.surname) {
				return this.arr.push(2)
			}

			if (!this.form.email) {
				return this.arr.push(3)
			}

			// this.$forceUpdate()
			// return
			// if (this.arr.length != 0) return
			// if (!this.form.email) {
			// 	return this.$message({
			// 		message: '请填写您的邮箱',
			// 		type: 'warning'
			// 	});
			// }
			let myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
			if (!myreg.test(this.form.email)) {
				return this.$message({
					message: this.$t('contact.inputZqEmail'),
					type: 'warning'
				});
			}

			const res = await submitContact(this.form)
			if (res.code == 200) {
				this.$message(res.msg);
				this.form = {
					surname: '',	// 姓
					name: '', 		// 名
					email: '',		// 邮箱
					message: '',	// 注释
				}
			} else {
				this.$message.error(res.msg);
			}

		}
	}
}
</script>

<style>
.contact {
	width: 100%;
	/* height: 59.875rem; */
	background: url(../assets/bg4.jpg) no-repeat center;
	background-size: cover;
}

.contact .box {
	padding: 5.625rem 0 6.25rem;
	max-width: 75rem;
	margin: 0 auto;
}

.contact .box p {
	/* display: inline-block; */
	margin: 0.625rem 0;
	font-size: 16px;
}

.contact .box>p {
	display: block;
	margin: 0;
	padding: 0;
}

.contact .box>p p {
	display: inline-block;
	margin: 0;
	padding: 0;
}

/* 表单 */
form {
	font-size: 14px;
	padding: 1.5rem 4rem 3rem;
	/* height: 523px; */
	background: #010E2C;
	opacity: 0.82;
	margin-top: 2rem;
}

.form-row {
	width: 100%;
	flex: 1;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}

.form-item {
	/* margin-top: 1.25rem; */
	flex: 1;

}

.form-item p {
	color: #00D8D4;
}

.item {
	max-width: 500px;
}

.form-item:nth-child(2) {
	margin-left: 20px;
}

.form-item input,
textarea {
	/* margin-top: 10px; */
	box-sizing: border-box;
	padding: 20px;
	font-size: 16px;
	outline: none;
	font-family: Microsoft YaHei;
	border: none;
	background-color: #eeeeee;
	caret-color: #333333;
	/* 焦点光标颜色 */
	color: #333333;
}

.form-item input {
	min-width: 300px;
	width: 100%;
	height: 50px;
}

.form-item textarea {
	width: 100%;
	/* width: 330px; */
	height: 80px;
}

.bottom {
	text-align: center;
}

.bottom input {
	width: 16rem;
	height: 3.5rem;
	border: none;
	margin-top: 30px;
	font-size: 16px;
	text-align: center;
}

#submit {
	background: #3C76E7;
	color: #000000;
	margin-right: 20px;
	background: linear-gradient(-45deg, #005AFF, #00DCD2);
}

@media screen and (max-width:480px) {
	.form-item:nth-child(2) {
		margin-left: 0px;
	}

	form {
		padding: 0.625rem;
	}

	.form-item input,
	textarea {
		padding: 10px;
	}
}
</style>
